export var CalendarType;
(function (CalendarType) {
    CalendarType["ICS"] = "ics";
    CalendarType["APPLE"] = "apple";
    CalendarType["GOOGLE"] = "google";
    CalendarType["YAHOO"] = "yahoo";
    CalendarType["OUTLOOK"] = "outlook";
})(CalendarType || (CalendarType = {}));
//# sourceMappingURL=types.js.map